import { FUEL_TYPE_DATA } from '../constants/carline-constants';
import { configProviderManager } from '../service/config-provider';

export const getBrand = (): string | undefined => {
	return configProviderManager.getBrand() ?? undefined;
};

export const isComerciales = (): boolean => {
	return getBrand() === 'N';
};

const ETIQUETA_ORDER = ['0', 'ECO', 'C'];

export const getEtiquetasDgt = (etiquetas: (string | null | undefined)[]): string[] =>
	[...etiquetas]
		.filter((etiqueta): etiqueta is string => Boolean(etiqueta))
		.sort((a, b) => ETIQUETA_ORDER.indexOf(a) - ETIQUETA_ORDER.indexOf(b))
		.map(getEtiquetaDgt)
		.filter((etiqueta): etiqueta is string => Boolean(etiqueta));

export const getEtiquetaDgt = (etiqueta?: string | null): string | undefined => {
	const etiquetaC = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_c.png';
	const etiquetaEco = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_eco.png';
	const etiquetaZero = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_0.png';

	switch (etiqueta) {
		case 'C':
			return etiquetaC;
		case '0':
			return etiquetaZero;
		case 'ECO':
			return etiquetaEco;
		default:
			return undefined;
	}
};

export const normalizeFuelTypeText = (fuelType: string): FUEL_TYPE_DATA | string => {
	if (fuelType == 'H\u00edbrido enchufable' || fuelType == 'Híbrido enchufable') {
		return FUEL_TYPE_DATA.HIBRIDO_ENCHUFABLE;
	} else if (fuelType == 'H\u00edbrido' || fuelType == 'Híbrido') {
		return FUEL_TYPE_DATA.HIBRIDO;
	} else if (fuelType == 'Gasolina mild Hybrid') {
		return FUEL_TYPE_DATA.HIBRIDO_ECO;
	} else if (fuelType == 'Gasolina') {
		return FUEL_TYPE_DATA.GASOLINA;
	} else if (fuelType == 'El\u00e9ctrico' || fuelType == 'Eléctrico') {
		return FUEL_TYPE_DATA.ELECTRICO;
	} else if (fuelType == 'Di\u00e9sel' || fuelType == 'Diésel') {
		return FUEL_TYPE_DATA.DIESEL;
	} else {
		return fuelType;
	}
};

export const getEtiquetaDgtFromFuelType = (fuelType: FUEL_TYPE_DATA | string) => {
	switch (fuelType) {
		case FUEL_TYPE_DATA.GASOLINA:
			return getEtiquetaDgt('C');
		case FUEL_TYPE_DATA.DIESEL:
			return getEtiquetaDgt('C');
		case FUEL_TYPE_DATA.HIBRIDO_ECO:
			return getEtiquetaDgt('ECO');
		case FUEL_TYPE_DATA.HIBRIDO_ENCHUFABLE:
			return getEtiquetaDgt('0');
		case FUEL_TYPE_DATA.HIBRIDO:
			return getEtiquetaDgt('ECO');
		case FUEL_TYPE_DATA.ELECTRICO:
			return getEtiquetaDgt('0');
		default:
			return undefined;
	}
};
